import deDE from './de_DE.json';
import enUS from './en_US.json';
import esES from './es_ES.json';
import frCA from './fr_CA.json';
import frFR from './fr_FR.json';
import itIT from './it_IT.json';
import ptBR from './pt_BR.json';
import zhCN from './zh_CN.json';
import bgBG from './bg_BG.json';
import csCZ from './cs_CZ.json';
import daDK from './da_DK.json';
import elGR from './el_GR.json';
import enGB from './en_GB.json';
import etEE from './et_EE.json';
import fiFI from './fi_FI.json';
import hrHR from './hr_HR.json';
import huHU from './hu_HU.json';
import jaJP from './ja_JP.json';
import koKR from './ko_KR.json';
import ltLT from './lt_LT.json';
import lvLV from './lv_LV.json';
import nlNL from './nl_NL.json';
import plPL from './pl_PL.json';
import ptPT from './pt_PT.json';
import roRO from './ro_RO.json';
import ruRU from './ru_RU.json';
import skSK from './sk_SK.json';
import slSI from './sl_SI.json';
import svSE from './sv_SE.json';
import trTR from './tr_TR.json';
import zhHK from './zh_HK.json';
import zhTW from './zh_TW.json';
import noNO from './no_NO.json';
import arSA from './ar_SA.json';
import heIL from './he_IL.json';
import thTH from './th_TH.json';
import ukUA from './uk_UA.json';

export default {
  bg_BG: bgBG,
  cs_CZ: csCZ,
  da_DK: daDK,
  de_DE: deDE,
  de_CH: deDE,
  de_AU: deDE,
  el_GR: elGR,
  el_CY: elGR,
  en_GB: enGB,
  en_US: enUS,
  es_ES: esES,
  et_EE: etEE,
  fi_FI: fiFI,
  fr_CA: frCA,
  fr_FR: frFR,
  fr_CH: frFR,
  fr_BE: frFR,
  fr_LU: frFR,
  hr_HR: hrHR,
  hu_HU: huHU,
  it_IT: itIT,
  it_CH: itIT,
  ja_JP: jaJP,
  ko_KR: koKR,
  lt_LT: ltLT,
  lv_LV: lvLV,
  nl_NL: nlNL,
  nl_BE: nlNL,
  pl_PL: plPL,
  pt_BR: ptBR,
  pt_PT: ptPT,
  ro_RO: roRO,
  ru_RU: ruRU,
  sk_SK: skSK,
  sl_SI: slSI,
  sv_SE: svSE,
  tr_TR: trTR,
  zh_CN: zhCN,
  zh_HK: zhHK,
  zh_TW: zhTW,
  no_NO: noNO,
  nb_NO: noNO,
  ar_SA: arSA,
  he_IL: heIL,
  th_TH: thTH,
  uk_UA: ukUA
};
